import React from 'react'
import PropTypes from 'prop-types'
import { ListItem, ListItemIcon, ListItemText, Grid, Skeleton, Typography, SvgIcon } from '@mui/material'
import { useCSDetailsCachedData } from 'components/configured-service/useCSDetailsCachedData'

const NoContentPlaceholder = () => <Typography>-</Typography>

const ServiceDetailsViewItem = ({ listItemTextSx, primary, secondary, icon, withPlaceholder = true, size = 6, ...rest }) => {
  const { isLoading } = useCSDetailsCachedData()
  return (
    <Grid size={size} {...rest}>
      <ListItem>
        <ListItemIcon sx={{ minWidth: 'auto', mr: 1 }}>
          <SvgIcon>{icon}</SvgIcon>
        </ListItemIcon>
        <ListItemText
          sx={listItemTextSx}
          primary={
            <>
              {isLoading && <Skeleton width={50} />}
              {!isLoading && primary}
              {!isLoading && !primary && withPlaceholder && <NoContentPlaceholder />}
            </>
          }
          secondary={secondary}
          slotProps={{
            primary: { variant: 'subtitle1', fontWeight: 500 },
            secondary: { variant: 'caption' },
          }}
        />
      </ListItem>
    </Grid>
  )
}

ServiceDetailsViewItem.propTypes = {
  isLoading: PropTypes.bool,
  listItemTextSx: PropTypes.object,
  primary: PropTypes.node,
  secondary: PropTypes.node,
  icon: PropTypes.node,
  withPlaceholder: PropTypes.bool,
  size: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
}

export default ServiceDetailsViewItem
